import React, { useState } from "react";
import {
  Button,
  Modal,
  Box,
  Typography,
  TextField,
  Stack,
  Tooltip,
  Snackbar,
  Alert,
} from "@mui/material";
import { FolderPlus } from "lucide-react";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const AddFolderButton = ({ userID, onSuccess }) => {
  const [open, setOpen] = useState(false);
  const [folderName, setFolderName] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // success | error

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setFolderName(""); // Reset the form on close
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const fullUrl = window.location.href; // Get the full URL
    const urlPath = new URL(fullUrl).pathname; // Extract the pathname from the URL
    const path = urlPath.split("/docvault/")[1] || ""; // Extract the path after "/docvault/"

    const data = {
      folderName,
      userID,
      path,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/doc-vault/create-folder`,
        data,
        { withCredentials: true }
      );
      // Handle success
      if (response.status === 200) {
        setSnackbarSeverity("success");
        setSnackbarMessage("Folder created successfully!");
        setSnackbarOpen(true);
        onSuccess(); // Call the onSuccess callback to refresh the folder structure
        closeModal(); 
      }
    } catch (e) {
      // Handle error
      console.error("Error creating folder:", e);
      setSnackbarSeverity("error");
      setSnackbarMessage("Failed to create folder.");
      setSnackbarOpen(true);
      closeModal(); 
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Tooltip title="Add Folder" arrow>
        <Button
          onClick={openModal}
          variant="outlined"
          color="success"
          size="small"
        >
          <FolderPlus size={"25"} />
        </Button>
      </Tooltip>
      <Modal
        open={open}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            gutterBottom
          >
            Create a New Folder
          </Typography>
          <form onSubmit={handleFormSubmit}>
            <Stack spacing={2}>
              <TextField
                label="Folder Name"
                variant="outlined"
                fullWidth
                value={folderName}
                onChange={(e) => setFolderName(e.target.value)}
                required
              />
              <Stack direction="row" spacing={2} justifyContent="flex-end">
                <Button variant="outlined" color="error" onClick={closeModal}>
                  Cancel
                </Button>
                <Button variant="contained" color="success" type="submit">
                  Add Folder
                </Button>
              </Stack>
            </Stack>
          </form>
        </Box>
      </Modal>

      {/* Snackbar for Notifications */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddFolderButton;
